module.exports = __webpack_public_path__ + "static/service01mb-fecd8de75ba98861e6bc8f7feea41686.jpg";